import React from 'react';

export default function DocumentsTableRow(props) {
	return <tr className={`DocumentsTable-row ${props.className}`} style={props.style}>{props.children}</tr>;
}

DocumentsTableRow.defaultProps = {
	className: ''
};
